import _extends from "@babel/runtime/helpers/extends";
import React from 'react';

// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Box, xcss } from '@atlaskit/primitives';
import Icon from '@atlaskit/icon';
var t25IconContainerStyles = {
  small: xcss({
    width: '16px',
    height: '16px'
  }),
  medium: xcss({
    width: '24px',
    height: '24px'
  }),
  large: xcss({
    width: '32px',
    height: '32px'
  }),
  //t25 tile icons do not get bumped up to 40/48px to avoid additional padding
  xlarge: xcss({
    width: '32x',
    height: '32px'
  })
};
var iconStyles = xcss({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center'
});
export function getLogoVersion(t25LogoComponent, LogoComponent) {
  return t25LogoComponent;
}
export function get3PLogo(iconGlyph, iconLabel) {
  return RovoLogoFromSVG(iconGlyph, iconLabel);
}
export var SVGIcon = function SVGIcon(_ref) {
  var SVG = _ref.glyph,
    label = _ref.label,
    size = _ref.size;
  return /*#__PURE__*/React.createElement(Box, {
    xcss: [t25IconContainerStyles[size], iconStyles],
    "aria-label": label
  }, /*#__PURE__*/React.createElement(SVG, null));
};
export var RovoLogoFromLogo = function RovoLogoFromLogo(LogoComponent) {
  var defaultLabel = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return function (_ref2) {
    var label = _ref2.label,
      testId = _ref2.testId;
    return /*#__PURE__*/React.createElement(LogoComponent, {
      label: label || defaultLabel,
      testId: testId,
      size: "small",
      appearance: "brand"
    });
  };
};

/**
 * Takes a logo component and returns a new logo component that uses the new logo design.
 */
export function RovoIconFromIcon(Icon) {
  return function (props) {
    return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
      shouldUseNewLogoDesign: true
    }));
  };
}
export var RovoLogoFromSVG = function RovoLogoFromSVG(glyph) {
  var defaultLabel = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return function (_ref3) {
    var _ref3$label = _ref3.label,
      label = _ref3$label === void 0 ? defaultLabel : _ref3$label;
    return /*#__PURE__*/React.createElement(SVGIcon, {
      label: label,
      glyph: glyph,
      size: "medium"
    });
  };
};
export var RovoLogoFromGlyph = function RovoLogoFromGlyph(glyph) {
  var defaultLabel = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return function (_ref4) {
    var _ref4$label = _ref4.label,
      label = _ref4$label === void 0 ? defaultLabel : _ref4$label,
      testId = _ref4.testId;
    return /*#__PURE__*/React.createElement(Icon, {
      label: label,
      testId: testId,
      glyph: glyph,
      size: "medium"
    });
  };
};